import { gql } from "@apollo/client";

export const GET_LISTA_PRECIOS_MASIVOS = gql`
query GetListaPreciosMasivos {
  listaPreciosMasivos {
    success,
    error,
    valorEsperado {
      idPreciosMasivos,
      fechaIngreso,
      cantidad,
      estado,
      autorizador,
      solicitante,
      usuarioEjecutador,
      fechaEjecucion,
      observaciones,
      idUsuarioAutorizador,
      idUsuarioSolicitante
    }
  } 
}
`;